const mixins = {
  computed: {
    isLoginPageActive() {
      return this.$route.name === 'Init';
    },
  },

  methods: {
    getEnvironmentLayoutName() {
      const LAYOUT_BY_ENV = {
        volkswagen: 'VolkswagenLayout',
        audi: 'AudiLayout',
        seat: 'SeatLayout',
        cupra: 'CupraLayout',
      };

      return LAYOUT_BY_ENV[process.env.VUE_APP_BRAND];
    },
  },
};

export default mixins;
